import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/(private)/profile')({
  component: Profile,
});

function Profile() {
  return <div>Hello "/(private)/profile"!</div>;
}
